import { render, staticRenderFns } from "./DriversReportDownload.vue?vue&type=template&id=bc48a8fa&"
import script from "./DriversReportDownload.vue?vue&type=script&lang=js&"
export * from "./DriversReportDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports